(function () {
  if (window.__hlCartMotion) return;
  window.__hlCartMotion = true;

  /* hl-cart-motion — the drawer's heights change with motion instead of in a
     frame. 2026-09-23, owner: "khi load thêm, height thay đổi, cần animation
     mượt, animation chèn vào, kể cả khi add từ PDP cũng vậy, chứ k load lại r
     thêm vào giật giật".

     Recorded before this, adding from the product page into an empty cart: the
     pinned summary went 176 -> 243 -> 357px in three separate frames inside a
     quarter of a second (the total, then the tier bar and the rail landing), and
     a new line item appeared at full height, pushing everything under it down in
     one jump.

     TWO THINGS, both measured after layout and before paint:

     1. THE SUMMARY. It is position:fixed at the bottom of the drawer, so when it
        grows its top edge jumps up. A ResizeObserver sees the new layout before
        it is painted; the summary is translated back to where its top edge WAS
        and animated to zero. Transform only — nothing is re-laid out per frame.
        A change arriving mid-animation starts from where the edge currently IS,
        so three quick changes read as one continuous movement. The summary's
        ::after (hl-cart-type.liquid) extends its background below it, so a
        summary that shrinks never shows a gap at the bottom while it settles.

     2. A NEW LINE ITEM opens from zero height, so the rows under it are pushed
        down smoothly instead of in one jump. This animates height, which does
        re-lay out per frame — accepted for one row for 280ms; there is no
        transform-only way to move the rows below it without measuring them all.
        Skipped when the cart was empty (the theme's own view transition fills
        the drawer then) and when the theme already put its own animation on it.

     Reduced motion: none of this runs. */

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var EASE = 'cubic-bezier(.2,.7,.3,1)';
  var DUR = 280;

  function drawerDialog() {
    return document.querySelector('#cart-drawer dialog');
  }
  function isOpen() {
    var d = drawerDialog();
    return !!(d && d.open);
  }
  function currentOffset(el) {
    var t = getComputedStyle(el).transform;
    if (!t || t === 'none') return 0;
    var m = t.match(/matrix(3d)?\(([^)]+)\)/);
    if (!m) return 0;
    var v = m[2].split(',').map(parseFloat);
    return m[1] ? v[13] : v[5];
  }

  /* ---- 1. the summary ------------------------------------------------- */
  var watched = null;
  var lastTop = null;
  var anim = null;
  var ro = typeof ResizeObserver === 'function' ? new ResizeObserver(function () {
    if (!watched) return;
    // Measured only while the drawer is open: a closed drawer reports 0, and
    // taking that as the "previous" edge made the summary fly in from the top
    // of the screen every time the drawer opened.
    if (!isOpen() || !watched.offsetHeight) { lastTop = null; return; }
    /* The VISIBLE top edge with any running animation taken out. offsetTop
       was right for the old position:fixed summary and is wrong for a sticky
       one: it reports where the summary would sit in flow, not where it is
       stuck. */
    var off = currentOffset(watched);
    var top = watched.getBoundingClientRect().top - off;
    var prev = lastTop;
    lastTop = top;
    if (prev === null || Math.abs(prev - top) < 1 || reduce.matches || !watched.animate) return;
    var from = prev + off - top;
    if (anim) anim.cancel();
    /* GROWTH ONLY. A summary that grew starts where its top edge was (lower)
       and rises; below it is the drawer's own edge, so nothing shows through.
       A summary that shrank would have to start ABOVE its place and leave a
       hole at the bottom while it settled — the old answer was a background
       tail, and that is exactly the thing the iPhone showed stuck. It simply
       settles instead. */
    if (from <= 0) return;
    anim = watched.animate(
      [{ transform: 'translateY(' + from + 'px)' }, { transform: 'none' }],
      { duration: DUR, easing: EASE }
    );
  }) : null;

  function watchSummary() {
    if (!ro) return;
    var s = document.querySelector('#cart-drawer .cart-drawer__summary');
    if (s === watched) return;
    var had = !!watched;
    if (watched) ro.unobserve(watched);
    watched = s;
    /* A REPLACED summary keeps the old one's edge as its starting point. The
       add from the rail swaps the whole summary node, and measuring the new one
       here — before the discount row and the badges have been put back into it
       — gave a baseline 63px too low, which then played as a jump. The first
       ResizeObserver callback on the new node (it always fires on observe)
       compares against the edge the shopper actually saw. */
    if (!had || !isOpen()) lastTop = s && isOpen() && s.offsetHeight ? s.getBoundingClientRect().top - currentOffset(s) : null;
    if (s) ro.observe(s);
  }

  /* ---- 2. new line items ----------------------------------------------- */
  var keys = null;   // row keys present at the last look
  function rowKeys() {
    var rows = document.querySelectorAll('#cart-drawer .cart-items__table-row[data-key]');
    var out = {};
    // By VARIANT, not by the full line key: the key's hash half changes when
    // the buy-2/3/4 tier changes, so every existing row looked new and the
    // whole list re-opened from zero on the add that crossed a tier.
    for (var i = 0; i < rows.length; i++) out[rows[i].dataset.key.split(':')[0]] = rows[i];
    return out;
  }
  /* A NEW ROW ARRIVES WITHOUT ANYTHING BEING RE-LAID OUT PER FRAME,
     2026-09-23 — owner: "Phần xuất hiện của item vào cart vẫn bị giật... phải
     có animation, nhẹ chuẩn đồng bộ minimalist và CẤM BỊ GIẬT".

     FLIP on transform and opacity only, which the compositor runs by itself:
       * every row that was already there, and the rail, is drawn where it WAS
         and slides to where it is now;
       * the new row fades in with a 6px settle, a beat later, so it is still
         transparent while the rows below pass through its space.

     WHERE IT WAS is remembered, not measured at mutation time. The first try
     measured the new row's pitch inside this observer — which runs before
     hl-ui-tweaks re-lays the rows out (its observer starts at
     DOMContentLoaded, after this deferred file), so it read the morph's raw
     layout and started the rows 48px too high: one visible frame of rows on
     top of each other. Positions are now stored in list coordinates (top +
     scrollTop) whenever the list is at rest, and the new ones are read in a
     microtask after every observer has run.

     The starting state is written inline as well: a new Web Animation is
     "pending" for its first frame, and inline style holds that frame. */
  var rest = {};        // variant | 'rail' -> top in list coordinates
  function listTop(el, scroller) {
    return el.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop;
  }
  function snapshot() {
    var drawer = document.getElementById('cart-drawer');
    var sc = drawer && drawer.querySelector('.cart-drawer__items');
    if (!sc || !isOpen()) return;
    var out = {};
    var rows = drawer.querySelectorAll('.cart-items__table-row[data-key]');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAnimations().length) return;   // not at rest
      out[rows[i].dataset.key.split(':')[0]] = listTop(rows[i], sc);
    }
    var rail = drawer.querySelector('.hl-rel--incart');
    if (rail && !rail.getAnimations().length) out.rail = listTop(rail, sc);
    rest = out;
  }
  function settle(el, anim) {
    var clear = function () { el.style.removeProperty('transform'); el.style.removeProperty('opacity'); snapshot(); };
    anim.onfinish = clear;
    anim.oncancel = clear;
  }
  function arrive(fresh) {
    var drawer = document.getElementById('cart-drawer');
    var sc = drawer && drawer.querySelector('.cart-drawer__items');
    if (!sc) return;
    var moved = 0;
    var rows = drawer.querySelectorAll('.cart-items__table-row[data-key]');
    var targets = [];
    for (var i = 0; i < rows.length; i++) {
      var k = rows[i].dataset.key.split(':')[0];
      if (fresh.indexOf(rows[i]) === -1 && k in rest) targets.push([rows[i], rest[k]]);
    }
    var rail = drawer.querySelector('.hl-rel--incart');
    if (rail && 'rail' in rest && !rail.getAnimations().length) targets.push([rail, rest.rail]);
    targets.forEach(function (t) {
      var d = t[1] - listTop(t[0], sc);
      if (Math.abs(d) < 1 || Math.abs(d) > 600) return;
      moved++;
      t[0].style.transform = 'translateY(' + d + 'px)';
      settle(t[0], t[0].animate(
        [{ transform: 'translateY(' + d + 'px)' }, { transform: 'none' }],
        { duration: DUR, easing: EASE }
      ));
    });
    fresh.forEach(function (row) {
      row.style.opacity = '0';
      settle(row, row.animate(
        [{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }],
        { duration: DUR - 40, delay: moved ? 120 : 0, easing: EASE, fill: 'backwards' }
      ));
    });
  }
  function checkRows() {
    var now = rowKeys();
    var before = keys;
    keys = now;
    if (!before || !isOpen() || reduce.matches) return;
    var hadAny = false;
    for (var k in before) { hadAny = true; break; }
    if (!hadAny) return;
    var fresh = [];
    for (var key in now) if (!(key in before)) fresh.push(now[key]);
    if (!fresh.length) return;
    // After every other observer (hl-ui-tweaks re-lays the rows out in its own)
    queueMicrotask(function () { arrive(fresh); });
  }

  /* ---- 3. the quantity stepper -------------------------------------------
     Owner: "+- quantity đang k có animation + load rõ ràng". Two things:

     THE NUMBER MOVES THE WAY THE TAP WENT. The theme writes the new value into
     the field on the click; one frame later it is slid in from below for +
     and from above for −, 180ms, transform and opacity only.

     THE STEPPER SAYS IT IS WAITING. The theme debounces 300ms, posts
     /cart/change and morphs — and showed nothing in between except the
     price's shimmer. data-hl-qbusy goes on the tapped stepper at the tap and
     comes off when the cart has answered: the morph rewrites the element's
     attributes from the server (so the flag simply is not in the new
     markup), and as a backstop when the theme lifts .cart-items-disabled, or
     after 8s. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('#cart-drawer .quantity-selector button');
    if (!btn || btn.disabled) return;
    var sel = btn.closest('.quantity-selector');
    var input = sel && sel.querySelector('input');
    if (!input) return;
    var dir = btn.name === 'minus' || btn.classList.contains('quantity-minus') ? -1 : 1;
    sel.setAttribute('data-hl-qbusy', '');
    clearTimeout(sel._hlQ);
    sel._hlQ = setTimeout(function () { sel.removeAttribute('data-hl-qbusy'); }, 8000);
    if (reduce.matches || !input.animate) return;
    requestAnimationFrame(function () {
      input.animate(
        // No end opacity: the busy state dims the number, and ending at 1
        // made it flash full then drop to .45.
        [{ transform: 'translateY(' + (dir * 7) + 'px)', opacity: 0 }, { transform: 'none' }],
        { duration: 180, easing: EASE }
      );
    });
  }, true);
  function clearBusyWhenIdle() {
    var comp = document.querySelector('#cart-drawer cart-items-component');
    if (!comp || comp._hlQWatch) return;
    comp._hlQWatch = true;
    new MutationObserver(function () {
      if (comp.classList.contains('cart-items-disabled')) return;
      var busy = document.querySelectorAll('#cart-drawer [data-hl-qbusy]');
      // Only once the request is done: the theme lifts the class in finally().
      for (var i = 0; i < busy.length; i++) busy[i].removeAttribute('data-hl-qbusy');
    }).observe(comp, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---- wiring ------------------------------------------------------------
     A MutationObserver callback runs after the morph and before paint, which
     is the window both halves need. The summary node itself can be replaced
     (the fallback path swaps the drawer's inner), so it is re-found each time. */
  function tick() {
    watchSummary();
    checkRows();
    clearBusyWhenIdle();
  }
  // Rest positions: taken when the drawer opens and after every settle.
  document.addEventListener('transitionend', function (e) {
    if (e.target && e.target.matches && e.target.matches('#cart-drawer dialog')) snapshot();
  }, true);
  setInterval(function () { if (isOpen()) snapshot(); }, 700);
  function start() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return false;
    new MutationObserver(tick).observe(drawer, { childList: true, subtree: true });
    tick();
    return true;
  }
  if (!start()) {
    var tries = 0;
    var iv = setInterval(function () { if (start() || ++tries > 20) clearInterval(iv); }, 300);
  }
})();
